import BackButton from 'components/BackButton';
import Button from 'components/Button';
import SkipButton from 'components/SkipButton';

import styles from './styles.module.scss';

const ModalFooter = ({
    backButtonClicked,
    backButtonDisabled,
    footerButtonClassName,
    footerButtonClicked,
    footerButtonDisabled,
    footerClassName,
    footerId = 'modelFooter',
    footerLabel,
    isSkip,
    isBack,
    skipButtonClassName,
    skipButtonClicked,
    skipButtonDisabled,
    skipButtonLabel
}) =>
    isSkip || isBack ? (
        <div className={`${footerClassName} ${styles.footerSkipBack}`}>
            <BackButton
                disabled={backButtonDisabled}
                onClick={backButtonClicked}
                id={footerId}
            />

            <div
                className={`${
                    skipButtonLabel === 'Skip to Plans' &&
                    styles.footerSkipAlign
                } ${styles.footerSkip}`}
            >
                <SkipButton
                    className={`${skipButtonClassName} ${styles.skipButton}`}
                    disabled={skipButtonDisabled}
                    label={skipButtonLabel}
                    onClick={skipButtonClicked}
                />

                <Button
                    className={footerButtonClassName}
                    disabled={footerButtonDisabled}
                    label={footerLabel}
                    onClick={footerButtonClicked}
                />
            </div>
        </div>
    ) : (
        <div className={`${footerClassName} ${styles.footer}`}>
            <Button
                className={footerButtonClassName}
                disabled={footerButtonDisabled}
                id={footerId}
                label={footerLabel}
                onClick={footerButtonClicked}
            />
        </div>
    );

export default ModalFooter;
